module.exports = __webpack_public_path__ + "img/personalization-block-icon.3713e6ec.svg";